var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "header-controls", attrs: { id: "header__controls__osmp" } },
    [
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "hide-footer": "",
            id: "feedbackModal",
            title: "Send Feedback"
          }
        },
        [_c("FeedbackModal", { ref: "refFeedbackModal" })],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { class: _vm.getHeaderClasses }, [
            _vm.$router.currentRoute.name != "permissionManager" &&
            _vm.$router.currentRoute.name != "globalAlert" &&
            _vm.$router.currentRoute.name != "userGlobalAlert"
              ? _c(
                  "div",
                  {
                    class:
                      "form-inline " +
                      (_vm.$router.currentRoute.name == "dashboard" ||
                      _vm.$router.currentRoute.name == "myWeek"
                        ? "deliverable-filter-form"
                        : "")
                  },
                  [
                    _c("div", { staticClass: "input-group top-search" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.searchQuery,
                            expression: "searchQuery"
                          },
                          {
                            name: "debounce",
                            rawName: "v-debounce:500ms",
                            value: _vm.setQuery,
                            expression: "setQuery",
                            arg: "500ms"
                          }
                        ],
                        ref: "searchQuery",
                        staticClass: "form-control",
                        class:
                          _vm.$router.currentRoute.name == "globalSearch"
                            ? ""
                            : "media-calls-search",
                        attrs: {
                          type: "text",
                          "debounce-events": ["keyup"],
                          placeholder: _vm.querySearchPlaceHolder,
                          id: "search-query"
                        },
                        domProps: { value: _vm.searchQuery },
                        on: {
                          click: function($event) {
                            return _vm.$refs.searchQuery.select()
                          },
                          keypress: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.triggerSearch.apply(null, arguments)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.searchQuery = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "input-group-append cursor-pointer",
                          on: { click: _vm.triggerSearch }
                        },
                        [_vm._m(0)]
                      )
                    ]),
                    _vm._v(" "),
                    _vm.$router.currentRoute.name != "globalSearch"
                      ? _c(
                          "b-button",
                          {
                            ref: "filterBoxBtn",
                            staticClass: "ml-2 mr-2 header-filter-btns",
                            attrs: {
                              id:
                                "sm-plan-popover-button-event-" + _vm.tabTitle,
                              variant: "theme",
                              tabindex: "0",
                              href: "#"
                            },
                            on: {
                              keydown: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "esc",
                                    27,
                                    $event.key,
                                    ["Esc", "Escape"]
                                  )
                                ) {
                                  return null
                                }
                                return _vm.$refs.popover.$emit("close")
                              }
                            }
                          },
                          [
                            _c(
                              "span",
                              {
                                class: {
                                  "wider-filter-only":
                                    _vm.$router.currentRoute.name ==
                                      "dashboard" ||
                                    _vm.$router.currentRoute.name == "myWeek"
                                }
                              },
                              [_vm._v("Filter")]
                            ),
                            _vm._v(" "),
                            _c("img", {
                              attrs: {
                                src: require("@/csmworkflow/img/filter.svg")
                              }
                            })
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "b-popover",
                      {
                        ref: "popover",
                        attrs: {
                          triggers: "click blur",
                          boundary: "window",
                          placement: "bottom",
                          target:
                            "sm-plan-popover-button-event-" + _vm.tabTitle,
                          "custom-class": "deliverable-filter"
                        }
                      },
                      [
                        _c("div", { staticClass: "d-flex flex-row" }, [
                          _c(
                            "div",
                            { staticClass: "filter-item item__status" },
                            [
                              _c("label", [_vm._v("Post Status")]),
                              _vm._v(" "),
                              !_vm.isMobile()
                                ? _c(
                                    "div",
                                    { staticClass: "status-wrap" },
                                    _vm._l(_vm.publishStatuses, function(
                                      s,
                                      index
                                    ) {
                                      return _c(
                                        "a",
                                        {
                                          key: index,
                                          staticClass: "badge mr-2",
                                          style: {
                                            color: "#fff",
                                            backgroundColor: s.color
                                          },
                                          attrs: { href: "#" },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.setPublishStatusFilter(
                                                s
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(s.name))]
                                      )
                                    }),
                                    0
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "custom-field status-field" },
                                [
                                  _vm.isMobile()
                                    ? _c("multiselect", {
                                        attrs: {
                                          searchable: true,
                                          label: "name",
                                          options: _vm.publishStatuses,
                                          placeholder: "Select post status",
                                          "show-labels": false,
                                          multiple: true,
                                          "hide-selected": true
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "option",
                                              fn: function(props) {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      style: {
                                                        color: "#fff",
                                                        borderRadius: "10px",
                                                        backgroundColor:
                                                          props.option.color,
                                                        height: "40px",
                                                        lineHeight: "40px",
                                                        textAlign: "center"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                          " +
                                                          _vm._s(
                                                            props.option.name
                                                          )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            },
                                            {
                                              key: "tag",
                                              fn: function(props) {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      style: {
                                                        color: "#fff",
                                                        borderRadius: "10px",
                                                        backgroundColor:
                                                          props.option.color,
                                                        textAlign: "center",
                                                        display: "inline-block",
                                                        padding: "5px 10px",
                                                        marginRight: "5px"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                          " +
                                                          _vm._s(
                                                            props.option.name
                                                          )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          3157095505
                                        ),
                                        model: {
                                          value:
                                            _vm.planFilterQuery.publishStatus,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.planFilterQuery,
                                              "publishStatus",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "planFilterQuery.publishStatus"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "grouped-filter-item" }, [
                            _c(
                              "div",
                              { staticClass: "filter-item item__coordinator" },
                              [
                                _c("label", [_vm._v("Assigned To")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "coordinator-wrap" },
                                  [
                                    _c("multiselect", {
                                      ref: "coordinatorFilter",
                                      attrs: {
                                        id: "coordinator",
                                        options: _vm.allActiveUsers,
                                        "show-labels": false,
                                        multiple: true,
                                        "open-direction": "bottom",
                                        label: "name",
                                        "track-by": "id",
                                        "hide-selected": true,
                                        "close-on-select": false,
                                        "clear-on-select": false
                                      },
                                      on: {
                                        select: _vm.onUpdateMultiselect,
                                        remove: _vm.onRemoveMultiselect
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "selection",
                                            fn: function(ref) {
                                              var values = ref.values
                                              var search = ref.search
                                              var isOpen = ref.isOpen
                                              return [
                                                values.length && !isOpen
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "multiselect__single"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            values.length
                                                          ) +
                                                            " options\n                            selected"
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        1024659988
                                      ),
                                      model: {
                                        value: _vm.selectedCoordinators,
                                        callback: function($$v) {
                                          _vm.selectedCoordinators = $$v
                                        },
                                        expression: "selectedCoordinators"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "filter-item item__social_network"
                              },
                              [
                                _c("label", [_vm._v("Social Network")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "social-network-wrap" },
                                  [
                                    _c("multiselect", {
                                      ref: "socialNetworkFilter",
                                      attrs: {
                                        id: "socialNetwork",
                                        options:
                                          _vm.systemSettings.social_networks ||
                                          [],
                                        "show-labels": false,
                                        multiple: true,
                                        "open-direction": "bottom",
                                        label: "network_name",
                                        "track-by": "id",
                                        "hide-selected": true,
                                        "close-on-select": false,
                                        "clear-on-select": false,
                                        "preserve-search": true,
                                        loading: !_vm.systemSettings
                                          .social_networks
                                      },
                                      on: {
                                        select: _vm.onUpdateMultiselect,
                                        remove: _vm.onRemoveMultiselect
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "option",
                                            fn: function(props) {
                                              return [
                                                _c("div", [
                                                  _c("i", {
                                                    class:
                                                      "fab fa-" +
                                                      _vm.getSocialNetworkClass(
                                                        props.option.api_type
                                                      )
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        props.option
                                                          .network_name
                                                      ) +
                                                      "\n                          "
                                                  )
                                                ])
                                              ]
                                            }
                                          },
                                          {
                                            key: "selection",
                                            fn: function(ref) {
                                              var values = ref.values
                                              var search = ref.search
                                              var isOpen = ref.isOpen
                                              return [
                                                values.length && !isOpen
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "multiselect__single"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            values.length
                                                          ) +
                                                            " options\n                            selected"
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        1663584892
                                      ),
                                      model: {
                                        value: _vm.selectedSocialNetworks,
                                        callback: function($$v) {
                                          _vm.selectedSocialNetworks = $$v
                                        },
                                        expression: "selectedSocialNetworks"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.namespace == ""
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "filter-item item__projectPlan"
                                  },
                                  [
                                    _c("label", [
                                      _vm._v("Project/Social Media Plan")
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "projectPlan-wrap" },
                                      [
                                        _c(
                                          "multiselect",
                                          {
                                            ref: "parentDeliverablesFilter",
                                            attrs: {
                                              id: "projectPlan",
                                              options: _vm.parentDeliverables,
                                              "show-labels": false,
                                              multiple: true,
                                              "open-direction": "bottom",
                                              label: "name",
                                              "track-by": "id",
                                              "hide-selected": true,
                                              "close-on-select": false,
                                              "clear-on-select": false,
                                              loading:
                                                _vm.isProjectPlansLoading,
                                              "preserve-search": true
                                            },
                                            on: {
                                              "search-change":
                                                _vm.onProjectPlanSearch,
                                              select: _vm.onUpdateMultiselect,
                                              remove: _vm.onRemoveMultiselect
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "selection",
                                                  fn: function(ref) {
                                                    var values = ref.values
                                                    var search = ref.search
                                                    var isOpen = ref.isOpen
                                                    return [
                                                      values.length && !isOpen
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "multiselect__single"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  values.length
                                                                ) +
                                                                  " options\n                            selected"
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  }
                                                },
                                                {
                                                  key: "option",
                                                  fn: function(props) {
                                                    return [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "option__desc"
                                                        },
                                                        [
                                                          props.option
                                                            .project_title
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "option__small text-muted"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      props
                                                                        .option
                                                                        .project_title
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          props.option
                                                            .project_title
                                                            ? _c("br")
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "option__title"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  props.option
                                                                    .deliverable_title
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              false,
                                              2211755155
                                            ),
                                            model: {
                                              value:
                                                _vm.selectedParentDeliverables,
                                              callback: function($$v) {
                                                _vm.selectedParentDeliverables = $$v
                                              },
                                              expression:
                                                "selectedParentDeliverables"
                                            }
                                          },
                                          [
                                            _vm._v(" "),
                                            _vm._v(" "),
                                            _c(
                                              "template",
                                              { slot: "noOptions" },
                                              [
                                                _vm._v(
                                                  "Start typing to find projects / plans."
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "template",
                                              { slot: "noResult" },
                                              [
                                                _vm._v(
                                                  "No results. Please try changing the search query."
                                                )
                                              ]
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "grouped-filter-item" }, [
                            _c(
                              "div",
                              { staticClass: "filter-item item__tag" },
                              [
                                _c("label", [_vm._v("Tag")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "tag-wrap" },
                                  [
                                    _c(
                                      "multiselect",
                                      {
                                        ref: "tagFilter",
                                        attrs: {
                                          id: "tag",
                                          options: _vm.tags,
                                          "show-labels": false,
                                          multiple: true,
                                          "open-direction": "bottom",
                                          label: "name",
                                          "track-by": "id",
                                          "hide-selected": true,
                                          "close-on-select": false,
                                          "clear-on-select": false,
                                          loading: _vm.isTagsLoading,
                                          "preserve-search": true
                                        },
                                        on: {
                                          "search-change": _vm.onTagSearch,
                                          select: _vm.onUpdateMultiselect,
                                          remove: _vm.onRemoveMultiselect
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "selection",
                                              fn: function(ref) {
                                                var values = ref.values
                                                var search = ref.search
                                                var isOpen = ref.isOpen
                                                return [
                                                  values.length && !isOpen
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "multiselect__single"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              values.length
                                                            ) +
                                                              " options\n                            selected"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          1024659988
                                        ),
                                        model: {
                                          value: _vm.selectedTags,
                                          callback: function($$v) {
                                            _vm.selectedTags = $$v
                                          },
                                          expression: "selectedTags"
                                        }
                                      },
                                      [
                                        _vm._v(" "),
                                        _c("template", { slot: "noOptions" }, [
                                          _vm._v("Start typing to find tags.")
                                        ]),
                                        _vm._v(" "),
                                        _c("template", { slot: "noResult" }, [
                                          _vm._v(
                                            "No results. Please try changing the search query."
                                          )
                                        ])
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "filter-item item__department" },
                              [
                                _c(
                                  "div",
                                  [
                                    _c("label", [_vm._v("Department")]),
                                    _vm._v(" "),
                                    _vm.isMobile()
                                      ? _c(
                                          "b-form-checkbox",
                                          {
                                            staticClass:
                                              "float-right csm-checkbox",
                                            attrs: {
                                              id: "no-department",
                                              name: "no-department",
                                              value: "accepted",
                                              "unchecked-value": "not_accepted"
                                            },
                                            on: {
                                              input: function($event) {
                                                _vm.planFilterQuery
                                                  .noDepartment == "accepted"
                                                  ? (_vm.planFilterQuery.department = [])
                                                  : ""
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.planFilterQuery
                                                  .noDepartment,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.planFilterQuery,
                                                  "noDepartment",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "planFilterQuery.noDepartment"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "No\n                        Department"
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "tag-wrap" },
                                  [
                                    _c(
                                      "multiselect",
                                      {
                                        ref: "departmentFilter",
                                        attrs: {
                                          id: "department",
                                          "open-direction": "bottom",
                                          label: "name",
                                          "track-by": "id",
                                          options: _vm.allActiveDepartments,
                                          "hide-selected": true,
                                          "show-labels": false,
                                          multiple: true,
                                          "close-on-select": false,
                                          "clear-on-select": false
                                        },
                                        on: {
                                          select: _vm.onUpdateMultiselect,
                                          remove: _vm.onRemoveMultiselect
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "selection",
                                              fn: function(ref) {
                                                var values = ref.values
                                                var search = ref.search
                                                var isOpen = ref.isOpen
                                                return [
                                                  values.length && !isOpen
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "multiselect__single"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              values.length
                                                            ) +
                                                              " options\n                            selected"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          1024659988
                                        ),
                                        model: {
                                          value: _vm.selectedDepartments,
                                          callback: function($$v) {
                                            _vm.selectedDepartments = $$v
                                          },
                                          expression: "selectedDepartments"
                                        }
                                      },
                                      [
                                        _vm._v(" "),
                                        _c("template", { slot: "noOptions" }, [
                                          _vm._v(
                                            "Start typing to find departments."
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("template", { slot: "noResult" }, [
                                          _vm._v(
                                            "No results. Please try changing the search query."
                                          )
                                        ])
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                !_vm.isMobile()
                                  ? _c(
                                      "b-form-checkbox",
                                      {
                                        staticClass: "mt-2 csm-checkbox",
                                        attrs: {
                                          id: "no-department",
                                          name: "no-department",
                                          value: "accepted",
                                          "unchecked-value": "not_accepted"
                                        },
                                        on: {
                                          input: function($event) {
                                            _vm.planFilterQuery.noDepartment ==
                                            "accepted"
                                              ? (_vm.planFilterQuery.department = [])
                                              : ""
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.planFilterQuery.noDepartment,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.planFilterQuery,
                                              "noDepartment",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "planFilterQuery.noDepartment"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "No\n                      Department"
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "filter-item item__date",
                              class: {
                                "filter-item-no-border":
                                  _vm.$router.currentRoute.name == "calendar"
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "due__created__dates" },
                                [
                                  _c(
                                    "div",
                                    [
                                      _c("label", { staticClass: "mt-2" }, [
                                        _vm._v("Created")
                                      ]),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c("date-range-picker", {
                                        ref: "pickerDateCreated",
                                        attrs: {
                                          autoApply: true,
                                          ranges: _vm.customCreatedDateRanges
                                        },
                                        on: { update: _vm.onUpdateDateCreated },
                                        model: {
                                          value:
                                            _vm.planFilterQuery
                                              .dateCreatedRange,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.planFilterQuery,
                                              "dateCreatedRange",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "planFilterQuery.dateCreatedRange"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c("label", { staticClass: "mt-lg-2" }, [
                                        _vm._v("Post Date")
                                      ]),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c("date-range-picker", {
                                        ref: "pickerPublishDate",
                                        attrs: {
                                          autoApply: true,
                                          ranges: _vm.customPublishDateRanges
                                        },
                                        on: { update: _vm.onUpdatePublishDate },
                                        model: {
                                          value:
                                            _vm.planFilterQuery
                                              .datePublishRange,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.planFilterQuery,
                                              "datePublishRange",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "planFilterQuery.datePublishRange"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c("label", { staticClass: "mt-lg-2" }, [
                                        _vm._v("Has Post Date")
                                      ]),
                                      _vm._v(" "),
                                      _c("multiselect", {
                                        class: "single-select",
                                        attrs: {
                                          id: "hasPostDate",
                                          options: _vm.hasPostDateFilterOptions,
                                          searchable: false,
                                          "close-on-select": true,
                                          "show-labels": false,
                                          label: "name",
                                          "track-by": "id",
                                          multiple: false
                                        },
                                        on: {
                                          select: _vm.onUpdateMultiselect,
                                          remove: _vm.onRemoveMultiselect
                                        },
                                        model: {
                                          value: _vm.selectedHasPostDate,
                                          callback: function($$v) {
                                            _vm.selectedHasPostDate = $$v
                                          },
                                          expression: "selectedHasPostDate"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", [
                            _c(
                              "div",
                              { staticClass: "item__reset" },
                              [
                                _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      variant: "theme",
                                      title: "Reset All Filter",
                                      size: "sm"
                                    },
                                    on: { click: _vm.resetFilter }
                                  },
                                  [_c("i", { staticClass: "fas fa-undo" })]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "d-block d-lg-none",
                                    attrs: {
                                      variant: "theme",
                                      title: "Close Filter Popup",
                                      size: "sm"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.$refs.popover.$emit("close")
                                      }
                                    }
                                  },
                                  [_c("i", { staticClass: "fas fa-times" })]
                                )
                              ],
                              1
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _vm.isFilterActive()
                          ? _c(
                              "div",
                              { staticClass: "d-none d-md-block mt-3" },
                              [
                                _c("label", [
                                  _vm._v("Click to remove filters :")
                                ]),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "badge badge-primary mr-2 mb-2",
                                    style: { cursor: "pointer" },
                                    on: { click: _vm.clearSearchFilter }
                                  },
                                  [_vm._v(_vm._s(_vm.planFilterQuery.query))]
                                ),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.planFilterQuery.publishStatus,
                                  function(publishStatus) {
                                    return _c(
                                      "span",
                                      {
                                        staticClass: "badge mr-2 mb-2",
                                        style: {
                                          cursor: "pointer",
                                          color: "#fff",
                                          backgroundColor: publishStatus.color
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.removeFilter(
                                              publishStatus
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v(_vm._s(publishStatus.name))]
                                    )
                                  }
                                ),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.planFilterQuery.socialNetwork,
                                  function(socialNetwork) {
                                    return _c(
                                      "span",
                                      {
                                        staticClass:
                                          "badge mr-2 mb-2 bg-primary cursor-pointer",
                                        staticStyle: { color: "#fff" },
                                        on: {
                                          click: function($event) {
                                            return _vm.removeFilter(
                                              socialNetwork
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          class:
                                            "fab fa-" +
                                            _vm.getSocialNetworkClass(
                                              socialNetwork.api_type
                                            )
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(socialNetwork.network_name)
                                        )
                                      ]
                                    )
                                  }
                                ),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.planFilterQuery.coordinator,
                                  function(coordinator) {
                                    return _c(
                                      "span",
                                      {
                                        staticClass:
                                          "badge badge-primary mr-2 mb-2",
                                        style: { cursor: "pointer" },
                                        on: {
                                          click: function($event) {
                                            return _vm.removeFilter(coordinator)
                                          }
                                        }
                                      },
                                      [_vm._v(_vm._s(coordinator.name))]
                                    )
                                  }
                                ),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.planFilterQuery.filterParentDeliverable,
                                  function(filterParentDeliverable) {
                                    return _c(
                                      "span",
                                      {
                                        staticClass:
                                          "badge badge-primary mr-2 mb-2",
                                        style: { cursor: "pointer" },
                                        on: {
                                          click: function($event) {
                                            return _vm.removeFilter(
                                              filterParentDeliverable
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(filterParentDeliverable.name)
                                        )
                                      ]
                                    )
                                  }
                                ),
                                _vm._v(" "),
                                _vm.planFilterQuery.filterByDateCreated
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "badge badge-primary mr-2 mb-2",
                                        style: { cursor: "pointer" },
                                        on: {
                                          click: function($event) {
                                            return _vm.removeFilter(
                                              "filterByDateCreated"
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Created: " +
                                            _vm._s(
                                              _vm._f("moment")(
                                                _vm.planFilterQuery
                                                  .dateCreatedRange.startDate,
                                                "MMM DD"
                                              )
                                            ) +
                                            " - " +
                                            _vm._s(
                                              _vm._f("moment")(
                                                _vm.planFilterQuery
                                                  .dateCreatedRange.endDate,
                                                "MMM DD"
                                              )
                                            )
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.planFilterQuery.filterByPublishDate
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "badge badge-primary mr-2 mb-2",
                                        style: { cursor: "pointer" },
                                        on: {
                                          click: function($event) {
                                            return _vm.removeFilter(
                                              "filterByPublishDate"
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Date to Post: " +
                                            _vm._s(
                                              _vm._f("moment")(
                                                _vm.planFilterQuery
                                                  .datePublishRange.startDate,
                                                "MMM DD"
                                              )
                                            ) +
                                            " - " +
                                            _vm._s(
                                              _vm._f("moment")(
                                                _vm.planFilterQuery
                                                  .datePublishRange.endDate,
                                                "MMM DD"
                                              )
                                            )
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(_vm.planFilterQuery.tag, function(tag) {
                                  return _c(
                                    "span",
                                    {
                                      staticClass:
                                        "badge badge-primary mr-2 mb-2",
                                      style: { cursor: "pointer" },
                                      on: {
                                        click: function($event) {
                                          return _vm.removeFilter(tag)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(tag.name))]
                                  )
                                }),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.planFilterQuery.socialSeries,
                                  function(socialSeries) {
                                    return _c(
                                      "span",
                                      {
                                        staticClass:
                                          "badge badge-primary mr-2 mb-2",
                                        style: { cursor: "pointer" },
                                        on: {
                                          click: function($event) {
                                            return _vm.removeFilter(
                                              socialSeries
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v(_vm._s(socialSeries.name))]
                                    )
                                  }
                                ),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.planFilterQuery.socialCampaign,
                                  function(socialCampaign) {
                                    return _c(
                                      "span",
                                      {
                                        staticClass:
                                          "badge badge-primary mr-2 mb-2",
                                        style: { cursor: "pointer" },
                                        on: {
                                          click: function($event) {
                                            return _vm.removeFilter(
                                              socialCampaign
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v(_vm._s(socialCampaign.name))]
                                    )
                                  }
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.planFilterQuery.department, function(
                                  department
                                ) {
                                  return _c(
                                    "span",
                                    {
                                      staticClass:
                                        "badge badge-primary mr-2 mb-2",
                                      style: { cursor: "pointer" },
                                      on: {
                                        click: function($event) {
                                          return _vm.removeFilter(department)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(department.name))]
                                  )
                                }),
                                _vm._v(" "),
                                _vm._l(_vm.planFilterQuery.project, function(
                                  project
                                ) {
                                  return _c(
                                    "span",
                                    {
                                      staticClass:
                                        "badge badge-primary mr-2 mb-2",
                                      style: { cursor: "pointer" },
                                      on: {
                                        click: function($event) {
                                          return _vm.removeFilter(project)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(project.title))]
                                  )
                                }),
                                _vm._v(" "),
                                _vm.planFilterQuery.noDepartment == "accepted"
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "badge badge-primary mr-2 mb-2",
                                        style: { cursor: "pointer" },
                                        on: {
                                          click: function($event) {
                                            _vm.planFilterQuery.noDepartment =
                                              "not_accepted"
                                          }
                                        }
                                      },
                                      [_vm._v("No Department")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.planFilterQuery.hasPostDate == "1"
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "badge badge-primary mr-2 mb-2",
                                        style: { cursor: "pointer" },
                                        on: {
                                          click: function($event) {
                                            return _vm.removeFilter(
                                              "hasPostDate"
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("Has Post Date")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.planFilterQuery.hasPostDate == "0"
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "badge badge-primary mr-2 mb-2",
                                        style: { cursor: "pointer" },
                                        on: {
                                          click: function($event) {
                                            return _vm.removeFilter(
                                              "hasPostDate"
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("No Post Date")]
                                    )
                                  : _vm._e()
                              ],
                              2
                            )
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _vm.$router.currentRoute.name == "mediaCallPage"
                      ? _c("div", { staticClass: "new-deliverables mr-2" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-theme header-filter-btns",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.createDeliverableDropdownClick({
                                    id: "media_call",
                                    name: "Media Call"
                                  })
                                }
                              }
                            },
                            [
                              _vm._v("\n                New Media Call "),
                              _c("i", {
                                staticClass:
                                  "fas text-primary float-right fa-plus fa-fw"
                              })
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.getSystemSetting(
                      "social_media___post_requires_plan"
                    ) || _vm.parentDeliverableId != null
                      ? _c("div", { staticClass: "new-deliverables mr-2" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-theme header-filter-btns",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.createDeliverableDropdownClick({
                                    id: "social_media",
                                    name: "Social Media"
                                  })
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                New Social Media Post "
                              ),
                              _c("i", {
                                staticClass:
                                  "fas text-primary float-right fa-plus fa-fw"
                              })
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.getSystemSetting(
                      "social_media___enable_social_campaign"
                    )
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "filter-item item__socialCampaigns mr-2",
                            staticStyle: { "max-width": "200px" }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "socialCampaigns-wrap" },
                              [
                                _c(
                                  "multiselect",
                                  {
                                    ref: "socialCampaignsFilter",
                                    attrs: {
                                      id: "socialCampaign",
                                      options: _vm.socialCampaigns,
                                      "show-labels": false,
                                      multiple: true,
                                      "open-direction": "bottom",
                                      label: "name",
                                      "track-by": "id",
                                      "hide-selected": true,
                                      "close-on-select": false,
                                      "clear-on-select": false,
                                      loading: _vm.isSocialCampaignsLoading,
                                      "preserve-search": true,
                                      placeholder: "Social Campaign"
                                    },
                                    on: {
                                      "search-change":
                                        _vm.onSocialCampaignSearch,
                                      select: _vm.onUpdateMultiselect,
                                      remove: _vm.onRemoveMultiselect
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "selection",
                                          fn: function(ref) {
                                            var values = ref.values
                                            var search = ref.search
                                            var isOpen = ref.isOpen
                                            return [
                                              values.length && !isOpen
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "multiselect__single"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(values.length) +
                                                          " options\n                      selected"
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      1278074772
                                    ),
                                    model: {
                                      value: _vm.planFilterQuery.socialCampaign,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.planFilterQuery,
                                          "socialCampaign",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "planFilterQuery.socialCampaign"
                                    }
                                  },
                                  [
                                    _vm._v(" "),
                                    _c("template", { slot: "noOptions" }, [
                                      _vm._v(
                                        "Start typing to find social campaign."
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("template", { slot: "noResult" }, [
                                      _vm._v(
                                        "No results. Please try changing the search query."
                                      )
                                    ])
                                  ],
                                  2
                                )
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.getSystemSetting("social_media___enable_social_series")
                      ? _c(
                          "div",
                          { staticClass: "filter-item item__socialSeries" },
                          [
                            _c(
                              "div",
                              { staticClass: "socialSeries-wrap" },
                              [
                                _c(
                                  "multiselect",
                                  {
                                    ref: "socialSeriesFilter",
                                    attrs: {
                                      id: "socialSeries",
                                      options: _vm.socialSeriesPlural,
                                      "show-labels": false,
                                      multiple: true,
                                      "open-direction": "bottom",
                                      label: "name",
                                      "track-by": "id",
                                      "hide-selected": true,
                                      "close-on-select": false,
                                      "clear-on-select": false,
                                      loading: _vm.isSocialSeriesLoading,
                                      "preserve-search": true,
                                      placeholder: "Multiple Date Posts"
                                    },
                                    on: {
                                      "search-change": _vm.onSocialSeriesSearch,
                                      select: _vm.onUpdateMultiselect,
                                      remove: _vm.onRemoveMultiselect
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "selection",
                                          fn: function(ref) {
                                            var values = ref.values
                                            var search = ref.search
                                            var isOpen = ref.isOpen
                                            return [
                                              values.length && !isOpen
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "multiselect__single"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(values.length) +
                                                          " options\n                      selected"
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      1278074772
                                    ),
                                    model: {
                                      value: _vm.planFilterQuery.socialSeries,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.planFilterQuery,
                                          "socialSeries",
                                          $$v
                                        )
                                      },
                                      expression: "planFilterQuery.socialSeries"
                                    }
                                  },
                                  [
                                    _vm._v(" "),
                                    _c("template", { slot: "noOptions" }, [
                                      _vm._v(
                                        "Start typing to find posts with multiple dates."
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("template", { slot: "noResult" }, [
                                      _vm._v(
                                        "No results. Please try changing the search query."
                                      )
                                    ])
                                  ],
                                  2
                                )
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showCreatedPostedDateSort
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "filter-item item__sortdates  d-inline-block float-right expand-all-area list-by-created-published mr-2"
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "ml-2 expand-grp cursor-pointer" },
                              [
                                _c(
                                  "b-button",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover",
                                        modifiers: { hover: true }
                                      }
                                    ],
                                    staticClass:
                                      "header-filter-btns expand-ctrls",
                                    class: {
                                      "none-active-btn": _vm.sortBy != "title"
                                    },
                                    attrs: {
                                      variant: "theme",
                                      title: "List By Post Name"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.setSortBy("title")
                                      }
                                    }
                                  },
                                  [
                                    _c("span", { staticClass: "text" }, [
                                      _vm._v("Post Name")
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover",
                                        modifiers: { hover: true }
                                      }
                                    ],
                                    staticClass:
                                      "header-filter-btns expand-ctrls",
                                    class: {
                                      "none-active-btn":
                                        _vm.sortBy != "publish_date"
                                    },
                                    attrs: {
                                      variant: "theme",
                                      title: "List By Posting Date"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.setSortBy("publish_date")
                                      }
                                    }
                                  },
                                  [
                                    _c("span", { staticClass: "text" }, [
                                      _vm._v("Posting Date")
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover",
                                        modifiers: { hover: true }
                                      }
                                    ],
                                    staticClass:
                                      "header-filter-btns expand-ctrls",
                                    class: {
                                      "none-active-btn":
                                        _vm.sortBy != "created_at"
                                    },
                                    attrs: {
                                      variant: "theme",
                                      title: "List By Created Date"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.setSortBy("created_at")
                                      }
                                    }
                                  },
                                  [
                                    _c("span", { staticClass: "text" }, [
                                      _vm._v("Created Date")
                                    ])
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "post-content-switcher-wrapper mr-2" },
                      [
                        _c(
                          "div",
                          { staticClass: "switch-toggle" },
                          [
                            _vm._l(_vm.systemSettings.languages, function(
                              lang,
                              idx
                            ) {
                              return [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.showPostContentLang,
                                      expression: "showPostContentLang"
                                    }
                                  ],
                                  staticClass: "no-focus-visible-outline",
                                  attrs: {
                                    id: "post_content_lang_" + idx,
                                    name: "post_content_lang",
                                    type: "radio"
                                  },
                                  domProps: {
                                    value: lang.id,
                                    checked: _vm._q(
                                      _vm.showPostContentLang,
                                      lang.id
                                    )
                                  },
                                  on: {
                                    change: function($event) {
                                      _vm.showPostContentLang = lang.id
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover",
                                        modifiers: { hover: true }
                                      }
                                    ],
                                    staticClass: "no-focus-visible-outline",
                                    attrs: {
                                      for: "post_content_lang_" + idx,
                                      title: lang.lang_name
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.showContentByLang(lang.id)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(lang.lang_code))]
                                )
                              ]
                            }),
                            _vm._v(" "),
                            _c("a", {
                              staticClass: "btn no-focus-visible-outline"
                            })
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "switch-toggle" },
                          [
                            _vm._l(_vm.getAvailableSocialNetworks, function(
                              network,
                              idx2
                            ) {
                              return [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.showPostContentNetwork,
                                      expression: "showPostContentNetwork"
                                    }
                                  ],
                                  staticClass: "no-focus-visible-outline",
                                  attrs: {
                                    id: "post_content_network_" + idx2,
                                    name: "post_content_network",
                                    type: "radio"
                                  },
                                  domProps: {
                                    value: network.id,
                                    checked: _vm._q(
                                      _vm.showPostContentNetwork,
                                      network.id
                                    )
                                  },
                                  on: {
                                    change: function($event) {
                                      _vm.showPostContentNetwork = network.id
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover",
                                        modifiers: { hover: true }
                                      }
                                    ],
                                    staticClass: "no-focus-visible-outline",
                                    attrs: {
                                      for: "post_content_network_" + idx2,
                                      title: network.network_name
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.showContentByNetwork(
                                          network.id
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      class:
                                        "fab fa-" +
                                        _vm.getSocialNetworkClass(
                                          network.api_type
                                        ) +
                                        " platform-indicator"
                                    })
                                  ]
                                )
                              ]
                            }),
                            _vm._v(" "),
                            _c("a", {
                              staticClass: "btn no-focus-visible-outline"
                            })
                          ],
                          2
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.showPlanProjectAll
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "filter-item item__sortdates  d-inline-block float-right expand-all-area list-by-created-published mr-2"
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "ml-2 expand-grp cursor-pointer" },
                              [
                                _c(
                                  "b-button",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover",
                                        modifiers: { hover: true }
                                      }
                                    ],
                                    staticClass:
                                      "header-filter-btns expand-ctrls",
                                    class: {
                                      "none-active-btn":
                                        _vm.showLimitedTo != "plan"
                                    },
                                    attrs: {
                                      variant: "theme",
                                      title: "Display posts from this plan"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.setLimit("parentDeliverable")
                                      }
                                    }
                                  },
                                  [
                                    _c("span", { staticClass: "text" }, [
                                      _vm._v("Plan")
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover",
                                        modifiers: { hover: true }
                                      }
                                    ],
                                    staticClass:
                                      "header-filter-btns expand-ctrls",
                                    class: {
                                      "none-active-btn":
                                        _vm.showLimitedTo != "project"
                                    },
                                    attrs: {
                                      variant: "theme",
                                      title: "Display posts from this project."
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.setLimit("project")
                                      }
                                    }
                                  },
                                  [
                                    _c("span", { staticClass: "text" }, [
                                      _vm._v("Project")
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover",
                                        modifiers: { hover: true }
                                      }
                                    ],
                                    staticClass:
                                      "header-filter-btns expand-ctrls",
                                    class: {
                                      "none-active-btn":
                                        _vm.showLimitedTo != "all"
                                    },
                                    attrs: {
                                      variant: "theme",
                                      title: "Display all Social Media Posts"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.setLimit("all")
                                      }
                                    }
                                  },
                                  [
                                    _c("span", { staticClass: "text" }, [
                                      _vm._v("All")
                                    ])
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.getSystemSetting("social_media___enable_post_import")
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "d-inline-block float-right saved-views-area pt-15 mr-2"
                          },
                          [
                            _c("div", { staticClass: "text-right" }, [
                              _c(
                                "div",
                                { staticClass: "group-by-wrap dropdown" },
                                [
                                  _vm._m(1),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "dropdown-menu" }, [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "dropdown-item",
                                        attrs: { type: "button", href: "#" },
                                        on: {
                                          click: _vm.exportSocialMediaExcel
                                        }
                                      },
                                      [_vm._v("Download Posts")]
                                    ),
                                    _vm._v(" "),
                                    _vm.getSystemSetting(
                                      "social_media___enable_post_import"
                                    )
                                      ? _c(
                                          "button",
                                          {
                                            staticClass: "dropdown-item",
                                            attrs: {
                                              type: "button",
                                              href: "#"
                                            },
                                            on: {
                                              click: _vm.importSocialMediaExcel
                                            }
                                          },
                                          [_vm._v("Import Posts")]
                                        )
                                      : _vm._e()
                                  ])
                                ]
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$router.currentRoute.name != "globalSearch" &&
                    _vm.$router.currentRoute.name != "calendar"
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "ml-2 mobile-expand-ctrls cursor-pointer mobile-filter-only"
                          },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "header-filter-btns expand-ctrls",
                                attrs: { variant: "theme" },
                                on: {
                                  click: function($event) {
                                    _vm.expandAll = !_vm.expandAll
                                    _vm.toggleStatusView()
                                  }
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.expandAll,
                                        expression: "!expandAll"
                                      }
                                    ],
                                    staticClass: "icon"
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fas text-primary fa-expand fa-fw"
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.expandAll,
                                        expression: "expandAll"
                                      }
                                    ],
                                    staticClass: "icon"
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fas text-primary fa-compress fa-fw"
                                    })
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$router.currentRoute.name == "myWeek" ||
                    _vm.$router.currentRoute.name == "dashboard"
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "ml-2 mobile-views-section cursor-pointer mobile-filter-only"
                          },
                          [
                            _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "b-modal",
                                    rawName: "v-b-modal.headerViewSelectModal",
                                    modifiers: { headerViewSelectModal: true }
                                  }
                                ],
                                ref: "MobileViewButton",
                                staticClass: "header-view-btns",
                                attrs: {
                                  variant: "theme",
                                  id: "MobileViewButton"
                                }
                              },
                              [
                                _c("span", { staticClass: "icon" }, [
                                  _c("i", {
                                    staticClass: "fas fa-fw fa-eye text-primary"
                                  })
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$router.currentRoute.name == "globalSearch"
                      ? _c(
                          "div",
                          { staticClass: "btn-group add-new__global_search" },
                          [
                            _c(
                              "b-button",
                              {
                                ref: "GSCreatedDate",
                                staticClass: "ml-md-2 header-filter-btns",
                                attrs: {
                                  variant: "theme",
                                  id: "GSCreatedDate"
                                },
                                on: {
                                  keydown: function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "esc",
                                        27,
                                        $event.key,
                                        ["Esc", "Escape"]
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.$refs.GSCreatedDatePopover.$emit(
                                      "close"
                                    )
                                  },
                                  click: function($event) {
                                    _vm.GSCreatedDatePopover = !_vm.GSCreatedDatePopover
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                Created Date\n                "
                                ),
                                _c("i", {
                                  staticClass:
                                    "far fa-calendar-check text-primary"
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-popover",
                              {
                                ref: "GSCreatedDatePopover",
                                attrs: {
                                  show: _vm.GSCreatedDatePopover,
                                  target: "GSCreatedDate",
                                  triggers: "click blur",
                                  placement: "bottom",
                                  "custom-class":
                                    "filter_popover__gs created-date-popover"
                                },
                                on: {
                                  "update:show": function($event) {
                                    _vm.GSCreatedDatePopover = $event
                                  }
                                }
                              },
                              [
                                _c("date-range-picker", {
                                  ref: "pickerDateCreated",
                                  attrs: {
                                    opens: "inline",
                                    autoApply: true,
                                    ranges: _vm.customCreatedDateRanges
                                  },
                                  on: { update: _vm.onUpdateDateCreated },
                                  model: {
                                    value: _vm.planFilterQuery.dateCreatedRange,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.planFilterQuery,
                                        "dateCreatedRange",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "planFilterQuery.dateCreatedRange"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$router.currentRoute.name == "globalSearch" &&
                    (_vm.GSDataType == "departments" ||
                      _vm.GSDataType == "tags" ||
                      _vm.GSDataType == "contacts" ||
                      _vm.GSDataType == "coordinators")
                      ? _c(
                          "div",
                          { staticClass: "btn-group add-new__global_search" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "ml-md-2 toggle-dept-status cursor-pointer",
                                on: {
                                  click: function($event) {
                                    _vm.planFilterQuery.status[0] == "Active"
                                      ? (_vm.planFilterQuery.status = [
                                          "Archived"
                                        ])
                                      : (_vm.planFilterQuery.status = [
                                          "Active"
                                        ])
                                  }
                                }
                              },
                              [
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "header-filter-btns",
                                    class: {
                                      "none-active-btn":
                                        _vm.planFilterQuery.status[0] !=
                                        "Active"
                                    },
                                    attrs: { variant: "theme" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  Active\n                  "
                                    ),
                                    _c("i", {
                                      staticClass:
                                        "fas fa-toggle-on text-primary float-right ml-2"
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "header-filter-btns",
                                    class: {
                                      "none-active-btn":
                                        _vm.planFilterQuery.status[0] !=
                                        "Archived"
                                    },
                                    attrs: { variant: "theme" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  Archived\n                  "
                                    ),
                                    _c("i", {
                                      staticClass:
                                        "fas fa-toggle-off text-primary float-right ml-2"
                                    })
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$router.currentRoute.name == "globalSearch" &&
                    (_vm.GSDataType == "departments" ||
                      _vm.GSDataType == "tags")
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "btn-group add-new__global_search sorting"
                          },
                          [
                            _vm._m(2),
                            _vm._v(" "),
                            _c("div", { staticClass: "dropdown-menu" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  attrs: { href: "#" },
                                  on: {
                                    click: function($event) {
                                      return _vm.setSort("usedDesc")
                                    }
                                  }
                                },
                                [_vm._v("Frequency Descending")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  attrs: { href: "#" },
                                  on: {
                                    click: function($event) {
                                      return _vm.setSort("usedAsc")
                                    }
                                  }
                                },
                                [_vm._v("Frequency Ascending")]
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$router.currentRoute.name == "globalSearch" &&
                    _vm.GSDataType == "all"
                      ? _c(
                          "div",
                          { staticClass: "btn-group add-new__global_search" },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass:
                                  "ml-md-2 header-filter-btns dropdown-toggle",
                                attrs: {
                                  variant: "theme",
                                  "data-toggle": "dropdown",
                                  "aria-haspopup": "true",
                                  "aria-expanded": "false"
                                }
                              },
                              [_vm._v("Add")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "dropdown-menu" }, [
                              _vm.userAbilities.createTag ||
                              _vm.userAbilities.editMediaCall
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      attrs: { href: "#" },
                                      on: {
                                        click: function($event) {
                                          return _vm.$emit("click", "tag")
                                        }
                                      }
                                    },
                                    [_vm._v("Add Tags")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.userAbilities.createContact ||
                              _vm.userAbilities.editMediaCall
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      attrs: { href: "#" },
                                      on: {
                                        click: function($event) {
                                          return _vm.$emit("click", "contact")
                                        }
                                      }
                                    },
                                    [_vm._v("Add Contacts")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.userAbilities.createUser
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      attrs: { href: "#" },
                                      on: {
                                        click: function($event) {
                                          return _vm.$emit(
                                            "click",
                                            "coordinator"
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Add User")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.userAbilities.createDepartment ||
                              _vm.userAbilities.editMediaCall
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      attrs: { href: "#" },
                                      on: {
                                        click: function($event) {
                                          return _vm.$emit(
                                            "click",
                                            "department"
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Add Departments")]
                                  )
                                : _vm._e()
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$router.currentRoute.name == "globalSearch" &&
                    _vm.GSDataType != "all"
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "btn-group add-new__global_search specific-btn",
                            class: !_vm.checkPermissions ? "no-permission" : ""
                          },
                          [
                            _vm.checkPermissions
                              ? _c(
                                  "b-button",
                                  {
                                    staticClass:
                                      "ml-md-2 header-filter-btns action",
                                    attrs: { variant: "theme" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        _vm.$emit(
                                          "click",
                                          _vm.GSDataType.substring(
                                            0,
                                            _vm.GSDataType.length - 1
                                          )
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Add\n                "
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "text-transform": "capitalize"
                                        }
                                      },
                                      [_vm._v(_vm._s(_vm.tabType))]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "btn-group" },
                              [
                                _vm.checkPermissions
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-theme dropdown-toggle options",
                                        attrs: {
                                          type: "button",
                                          "data-toggle": "dropdown",
                                          "aria-haspopup": "true",
                                          "aria-expanded": "false"
                                        }
                                      },
                                      [
                                        _c("span", { staticClass: "sr-only" }, [
                                          _vm._v("Toggle Dropdown")
                                        ])
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.checkPermissions
                                  ? _c(
                                      "b-button",
                                      {
                                        staticClass:
                                          "ml-md-2 header-filter-btns dropdown-toggle",
                                        attrs: {
                                          variant: "theme",
                                          "data-toggle": "dropdown",
                                          "aria-haspopup": "true",
                                          "aria-expanded": "false"
                                        }
                                      },
                                      [_vm._v("Add")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "dropdown-menu" }, [
                                  _vm.GSDataType != "tags" &&
                                  (_vm.userAbilities.createTag ||
                                    _vm.userAbilities.editMediaCall)
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "dropdown-item",
                                          attrs: { href: "#" },
                                          on: {
                                            click: function($event) {
                                              return _vm.$emit("click", "tag")
                                            }
                                          }
                                        },
                                        [_vm._v("Add Tags")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.GSDataType != "contacts" &&
                                  (_vm.userAbilities.createContact ||
                                    _vm.userAbilities.editMediaCall)
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "dropdown-item",
                                          attrs: { href: "#" },
                                          on: {
                                            click: function($event) {
                                              return _vm.$emit(
                                                "click",
                                                "contact"
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("Add Contacts")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.GSDataType != "coordinators" &&
                                  _vm.userAbilities.createUser
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "dropdown-item",
                                          attrs: { href: "#" },
                                          on: {
                                            click: function($event) {
                                              return _vm.$emit(
                                                "click",
                                                "coordinator"
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("Add User")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.GSDataType != "departments" &&
                                  (_vm.userAbilities.createDepartment ||
                                    _vm.userAbilities.editMediaCall)
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "dropdown-item",
                                          attrs: { href: "#" },
                                          on: {
                                            click: function($event) {
                                              return _vm.$emit(
                                                "click",
                                                "department"
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("Add Departments")]
                                      )
                                    : _vm._e()
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "ml-2" }, [_c("FeedbackBtn")], 1)
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isFilterActive()
              ? _c(
                  "div",
                  { staticClass: "mt-3 filter-badges" },
                  [
                    _c("label", { staticClass: "remove-filter-text" }, [
                      _vm._v("Click to remove filters:")
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "badge badge-primary mr-2 mb-2",
                        style: { cursor: "pointer" },
                        on: { click: _vm.clearSearchFilter }
                      },
                      [_vm._v(_vm._s(_vm.planFilterQuery.query))]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.planFilterQuery.publishStatus, function(
                      publishStatus
                    ) {
                      return _c(
                        "span",
                        {
                          staticClass: "badge mr-2 mb-2",
                          style: {
                            cursor: "pointer",
                            color: "#fff",
                            backgroundColor: publishStatus.color
                          },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter(publishStatus)
                            }
                          }
                        },
                        [_vm._v(_vm._s(publishStatus.name))]
                      )
                    }),
                    _vm._v(" "),
                    _vm.$router.currentRoute.name == "globalSearch" &&
                    _vm.planFilterQuery.sort
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "badge mr-2 mb-2 bg-primary cursor-pointer",
                            staticStyle: { color: "#fff" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("resetDepartTagSort")
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.planFilterQuery.sort == "usedDesc"
                                  ? "Frequency Descending"
                                  : "Frequency Ascending"
                              )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.planFilterQuery.socialNetwork, function(
                      socialNetwork
                    ) {
                      return _c(
                        "span",
                        {
                          staticClass:
                            "badge mr-2 mb-2 bg-primary cursor-pointer",
                          staticStyle: { color: "#fff" },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter(socialNetwork)
                            }
                          }
                        },
                        [
                          _c("i", {
                            class:
                              "fab fa-" +
                              _vm.getSocialNetworkClass(socialNetwork.api_type)
                          }),
                          _vm._v(" " + _vm._s(socialNetwork.network_name))
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _vm._l(
                      _vm.planFilterQuery.filterParentDeliverable,
                      function(filterParentDeliverable) {
                        return _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter(filterParentDeliverable)
                              }
                            }
                          },
                          [_vm._v(_vm._s(filterParentDeliverable.name))]
                        )
                      }
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.planFilterQuery.coordinator, function(
                      coordinator
                    ) {
                      return _c(
                        "span",
                        {
                          staticClass: "badge badge-primary mr-2 mb-2",
                          style: { cursor: "pointer" },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter(coordinator)
                            }
                          }
                        },
                        [_vm._v(_vm._s(coordinator.name))]
                      )
                    }),
                    _vm._v(" "),
                    _vm.planFilterQuery.filterByDateCreated
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("filterByDateCreated")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "Created: " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.planFilterQuery.dateCreatedRange
                                      .startDate,
                                    "MMM DD"
                                  )
                                ) +
                                " - " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.planFilterQuery.dateCreatedRange
                                      .endDate,
                                    "MMM DD"
                                  )
                                )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.planFilterQuery.filterByPublishDate
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("filterByPublishDate")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "Date to Post: " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.planFilterQuery.datePublishRange
                                      .startDate,
                                    "MMM DD"
                                  )
                                ) +
                                " - " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.planFilterQuery.datePublishRange
                                      .endDate,
                                    "MMM DD"
                                  )
                                )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.planFilterQuery.tag, function(tag) {
                      return _c(
                        "span",
                        {
                          staticClass: "badge badge-primary mr-2 mb-2",
                          style: { cursor: "pointer" },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter(tag)
                            }
                          }
                        },
                        [_vm._v(_vm._s(tag.name))]
                      )
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.planFilterQuery.socialSeries, function(
                      socialSeries
                    ) {
                      return _c(
                        "span",
                        {
                          staticClass: "badge badge-primary mr-2 mb-2",
                          style: { cursor: "pointer" },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter(socialSeries)
                            }
                          }
                        },
                        [_vm._v(_vm._s(socialSeries.name))]
                      )
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.planFilterQuery.socialCampaign, function(
                      socialCampaign
                    ) {
                      return _c(
                        "span",
                        {
                          staticClass: "badge badge-primary mr-2 mb-2",
                          style: { cursor: "pointer" },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter(socialCampaign)
                            }
                          }
                        },
                        [_vm._v(_vm._s(socialCampaign.name))]
                      )
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.planFilterQuery.department, function(
                      department
                    ) {
                      return _c(
                        "span",
                        {
                          staticClass: "badge badge-primary mr-2 mb-2",
                          style: { cursor: "pointer" },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter(department)
                            }
                          }
                        },
                        [_vm._v(_vm._s(department.name))]
                      )
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.planFilterQuery.project, function(project) {
                      return _c(
                        "span",
                        {
                          staticClass: "badge badge-primary mr-2 mb-2",
                          style: { cursor: "pointer" },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter(project)
                            }
                          }
                        },
                        [_vm._v(_vm._s(project.title))]
                      )
                    }),
                    _vm._v(" "),
                    _vm.planFilterQuery.noDepartment == "accepted"
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                _vm.planFilterQuery.noDepartment =
                                  "not_accepted"
                              }
                            }
                          },
                          [_vm._v("No Department")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.planFilterQuery.hasPostDate == "1"
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("hasPostDate")
                              }
                            }
                          },
                          [_vm._v("Has Post Date")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.planFilterQuery.hasPostDate == "0"
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("hasPostDate")
                              }
                            }
                          },
                          [_vm._v("No Post Date")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.planFilterQuery.weekFilterOptions.overdue
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("overdue")
                              }
                            }
                          },
                          [_vm._v("overdue")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.planFilterQuery.weekFilterOptions.today
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("today")
                              }
                            }
                          },
                          [_vm._v("today")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.planFilterQuery.weekFilterOptions.thisWeek
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("thisWeek")
                              }
                            }
                          },
                          [_vm._v("this week")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.planFilterQuery.weekFilterOptions.nextWeek
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("nextWeek")
                              }
                            }
                          },
                          [_vm._v("next week")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.planFilterQuery.weekFilterOptions.upcoming
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("upcoming")
                              }
                            }
                          },
                          [_vm._v("upcoming")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.planFilterQuery.weekFilterOptions.noDeadline
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("noDeadline")
                              }
                            }
                          },
                          [_vm._v("no deadline")]
                        )
                      : _vm._e()
                  ],
                  2
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.showLogo
            ? _c(
                "div",
                {
                  staticClass: "col-sm-5 col-md-4 col-4 text-right right-side"
                },
                [
                  _c(
                    "div",
                    { staticClass: "logo-user" },
                    [
                      _c("HeaderNotification"),
                      _vm._v(" "),
                      _c("LoggedInUser"),
                      _vm._v(" "),
                      _c("Logo")
                    ],
                    1
                  )
                ]
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "hide-footer": "",
            id: "socialMediaExportModal",
            title: "Creating Social Media Export"
          },
          model: {
            value: _vm.showSocialMediaExportModal,
            callback: function($$v) {
              _vm.showSocialMediaExportModal = $$v
            },
            expression: "showSocialMediaExportModal"
          }
        },
        [
          _c(
            "div",
            { staticStyle: { "text-align": "center" } },
            [
              _vm.isLoadingExport
                ? _c("b-spinner", { attrs: { label: "Loading" } })
                : _vm._e(),
              _vm._v(" "),
              !_vm.isLoadingExport
                ? _c("div", [
                    _vm.downloadLink
                      ? _c(
                          "a",
                          {
                            staticClass: "btn btn-primary",
                            attrs: { href: _vm.downloadLink },
                            on: {
                              click: function($event) {
                                _vm.showSocialMediaExportModal = false
                              }
                            }
                          },
                          [_vm._v("Download")]
                        )
                      : _vm._e()
                  ])
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "hide-footer": "",
            "hide-backdrop": "",
            "no-close-on-backdrop": "",
            "content-class": "shadow",
            id: "socialMediaImportModal",
            title: "Import Social Media Posts"
          },
          model: {
            value: _vm.showSocialMediaImportModal,
            callback: function($$v) {
              _vm.showSocialMediaImportModal = $$v
            },
            expression: "showSocialMediaImportModal"
          }
        },
        [
          _c("p", [
            _c("ul", [
              _c("li", [
                _c(
                  "a",
                  {
                    attrs: {
                      href: "/assets/import-social-media.xlsx",
                      target: "_blank"
                    }
                  },
                  [_vm._v("Download example .xlsx file")]
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "We recommend importing less than 30 new social media posts at a time to reduce the file size and processing time of the excel spreadsheet."
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isProcessingImport,
                  expression: "isProcessingImport"
                }
              ],
              staticClass: "status-processing-import-file"
            },
            [
              _c("div", {
                staticClass:
                  "ml-2 spinner-border spinner-border-sm text-primary",
                attrs: { role: "status" }
              }),
              _vm._v(" "),
              _c("span", [
                _vm._v("Loading and Processing Import Entries."),
                _c("br"),
                _vm._v("This may take several minutes.")
              ])
            ]
          ),
          _vm._v(" "),
          _c("VueFilePond", {
            ref: "importPond",
            attrs: {
              name: "file",
              "label-idle": "Upload .xlsx",
              "allow-multiple": true,
              dropOnElement: true,
              dropOnPage: false,
              allowRevert: false,
              files: _vm.filepond,
              credits: "false"
            },
            on: { init: _vm.handleFilePondInit }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.loadedImportResults,
                  expression: "loadedImportResults"
                }
              ],
              staticClass: "imported-results"
            },
            [
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "b-toggle",
                      rawName: "v-b-toggle.collapse-import-results",
                      modifiers: { "collapse-import-results": true }
                    }
                  ],
                  attrs: { variant: "text" }
                },
                [
                  _c("i", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.expandImportResults,
                        expression: "!expandImportResults"
                      }
                    ],
                    staticClass: "fas fa-chevron-down collapse-indicator"
                  }),
                  _vm._v(" "),
                  _c("i", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.expandImportResults,
                        expression: "expandImportResults"
                      }
                    ],
                    staticClass: "fas fa-chevron-right collapse-indicator"
                  }),
                  _vm._v(" "),
                  _vm.importedResults.errors.length > 0
                    ? _c(
                        "strong",
                        {
                          staticStyle: { color: "var(--error--color--border)" }
                        },
                        [
                          _vm._v(
                            "ERROR: " +
                              _vm._s(_vm.importedResults.errors.length) +
                              " row(s) have problems."
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("strong", [
                    _vm._v(
                      _vm._s(_vm.importedResults.imported.length) +
                        " posts imported."
                    )
                  ]),
                  _vm._v(" "),
                  _c("strong", [
                    _vm._v(
                      _vm._s(_vm.importedResults.total) + " data rows in file."
                    )
                  ]),
                  _vm._v(" "),
                  _c("strong", [_vm._v("Click to view details.")]),
                  _vm._v(" "),
                  _c("br")
                ]
              ),
              _vm._v(" "),
              _c(
                "b-collapse",
                {
                  attrs: { id: "collapse-import-results" },
                  model: {
                    value: _vm.expandImportResults,
                    callback: function($$v) {
                      _vm.expandImportResults = $$v
                    },
                    expression: "expandImportResults"
                  }
                },
                [
                  _c("div", { staticClass: "collapse-inner" }, [
                    _vm.importedResults.errors.length > 0
                      ? _c(
                          "ol",
                          _vm._l(_vm.importedResults.errors, function(
                            e,
                            indexe
                          ) {
                            return _c(
                              "li",
                              {
                                class:
                                  "{e.new ? 'imported-new':'imported-existing'}"
                              },
                              [
                                _c("span", { staticClass: "imported-title" }, [
                                  _vm._v(_vm._s(e.title))
                                ]),
                                _vm._v(" "),
                                e.publish_date != null
                                  ? _c("span", {
                                      staticClass: "imported-publish_date",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.localMomentFull(e.publish_date)
                                        )
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                e.publish_date == null
                                  ? _c(
                                      "span",
                                      { staticClass: "imported-publish_date" },
                                      [_vm._v("No Date Set")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                e.social_campaign
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "imported-social_campaign"
                                      },
                                      [
                                        _vm._v(
                                          "Campaign: " +
                                            _vm._s(e.social_campaign.title)
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                e.social_series
                                  ? _c(
                                      "span",
                                      { staticClass: "imported-social_series" },
                                      [
                                        _vm._v(
                                          "Series: " +
                                            _vm._s(e.social_series.title)
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { class: _vm.getImportStatusClass(e.status) },
                                  [
                                    _vm._v(
                                      "Row " +
                                        _vm._s(e.row) +
                                        "; " +
                                        _vm._s(e.status.name)
                                    )
                                  ]
                                )
                              ]
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.importedResults.imported.length > 0
                      ? _c(
                          "ol",
                          _vm._l(_vm.importedResults.imported, function(
                            s,
                            index
                          ) {
                            return _c(
                              "li",
                              {
                                class:
                                  "{s.new ? 'imported-new':'imported-existing'}"
                              },
                              [
                                _c("span", { staticClass: "imported-title" }, [
                                  _c(
                                    "a",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.showEditDeliverableModal(s)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(s.title))]
                                  )
                                ]),
                                _vm._v(" "),
                                s.publish_date != null
                                  ? _c("span", {
                                      staticClass: "imported-publish_date",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.localMomentFull(s.publish_date)
                                        )
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                s.publish_date == null
                                  ? _c(
                                      "span",
                                      { staticClass: "imported-publish_date" },
                                      [_vm._v("No Date Set")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                s.social_campaign
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "imported-social_campaign"
                                      },
                                      [
                                        _vm._v(
                                          "Campaign: " +
                                            _vm._s(s.social_campaign.title)
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                s.social_series
                                  ? _c(
                                      "span",
                                      { staticClass: "imported-social_series" },
                                      [
                                        _vm._v(
                                          "Series: " +
                                            _vm._s(s.social_series.title)
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { class: _vm.getImportStatusClass(s.status) },
                                  [
                                    _vm._v(
                                      "Row " +
                                        _vm._s(s.row) +
                                        "; " +
                                        _vm._s(s.status.name)
                                    )
                                  ]
                                )
                              ]
                            )
                          }),
                          0
                        )
                      : _vm._e()
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "input-group-text" }, [
      _c("i", { staticClass: "fas fa-search" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn btn-theme header-filter-btns",
        attrs: { type: "button", "data-toggle": "dropdown" }
      },
      [
        _vm._v("Export/Import"),
        _c("i", {
          staticClass: "fas text-primary float-right fa-chevron-down fa-fw"
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn btn-theme ml-md-2 header-filter-btns dropdown-toggle",
        attrs: {
          type: "button",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false"
        }
      },
      [
        _vm._v("\n                Sort\n                "),
        _c("i", { staticClass: "fas fa-sort text-primary float-right" })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }